import React from "react";
import {
  CreateAccountDesktopContainer,
  CreateAccountDesktopFormCell,
  CreateAccountDesktopColorBackground,
  CreateAccountDesktopGradientLayer,
  CreateAccountDesktopBrandPanel,
  CreateAccountDesktopBrandRow,
  CreateAccountDesktopBrandTitleAside,
  CreateAccountDesktopBrandLockup,
  CreateAccountDesktopBrandTitleImg,
  CreateAccountNonDesktopShell,
  CreateAccountHeroBand,
  CreateAccountHeroLockupImg,
  CreateAccountHeroTitleImg,
  CreateAccountNonDesktopContents,
} from "./CreateAccountForm.styles";
import providerPortalLockup from "../../assets/logos/provider-portal/unity-vert-cobranded.svg";
import providerPortalLockupHorizontal from "../../assets/logos/provider-portal/unity-horiz-cobranded.svg";
import providerPortalTitle from "../../assets/logos/provider-portal/provider-portal-title.svg";

import { CreateAccountFormContent } from "./CreateAccountFormContent";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

export const CreateAccountForm = (): React.ReactElement => {
  const { isDesktop, deviceType } = useDeviceHook();

  return (
    <>
      {isDesktop && (
        <CreateAccountDesktopContainer>
          <CreateAccountDesktopColorBackground>
            <CreateAccountDesktopGradientLayer aria-hidden />
            <CreateAccountDesktopBrandPanel>
              <CreateAccountDesktopBrandRow>
                <CreateAccountDesktopBrandLockup
                  src={providerPortalLockup}
                  alt="Unity by BillionToOne"
                />
                <CreateAccountDesktopBrandTitleAside>
                  <CreateAccountDesktopBrandTitleImg
                    src={providerPortalTitle}
                    alt="Provider Portal"
                  />
                </CreateAccountDesktopBrandTitleAside>
              </CreateAccountDesktopBrandRow>
            </CreateAccountDesktopBrandPanel>
          </CreateAccountDesktopColorBackground>
          <CreateAccountDesktopFormCell>
            <CreateAccountFormContent />
          </CreateAccountDesktopFormCell>
        </CreateAccountDesktopContainer>
      )}
      {!isDesktop && (
        <CreateAccountNonDesktopShell>
          <CreateAccountHeroBand $deviceType={deviceType}>
            <CreateAccountHeroLockupImg
              $deviceType={deviceType}
              src={providerPortalLockupHorizontal}
              alt="Unity by BillionToOne"
            />
            <CreateAccountHeroTitleImg
              $deviceType={deviceType}
              src={providerPortalTitle}
              alt="Provider Portal"
            />
          </CreateAccountHeroBand>
          <CreateAccountNonDesktopContents $deviceType={deviceType}>
            <CreateAccountFormContent />
          </CreateAccountNonDesktopContents>
        </CreateAccountNonDesktopShell>
      )}
    </>
  );
};
